var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8426 5.81543L10.9532 9.70393L7.06472 5.81543L5.76855 7.1116L9.65705 11.0001L5.76855 14.8886L7.06472 16.1848L10.9532 12.2963L14.8426 16.1848L16.1388 14.8886L12.2503 11.0001L16.1388 7.1116L14.8426 5.81543Z",
    fill: "#E0E6ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhite);
export default __webpack_public_path__ + "static/media/x-white.c3a8bd51f27fd5b8178cea7cbeee7ae4.svg";
export { ForwardRef as ReactComponent };